export var SubscriptionTermEnum;
(function(SubscriptionTermEnum) {
  SubscriptionTermEnum[(SubscriptionTermEnum["Annual"] = 1)] = "Annual";
  SubscriptionTermEnum[(SubscriptionTermEnum["Quarterly"] = 2)] = "Quarterly";
  SubscriptionTermEnum[(SubscriptionTermEnum["Monthly"] = 3)] = "Monthly";
})(SubscriptionTermEnum || (SubscriptionTermEnum = {}));
